import { useGlobal } from '@/utils/useGlobal';
import styles from './index.module.scss';
import EFPicture from '@elem/ui/ef-picture';

const WholeHome = () => {
    const { useLang } = useGlobal();
    const { t } = useLang('OceanProHomeSolarBattery');
    return (
        <div className={`${styles.wholeHome} GtmModuleData-section`} data-section-id={styles.wholeHome} data-section-title={t(`Whole_home_title`)}>
            <EFPicture
                src={'https://websiteoss.ecoflow.com/upload/image/1751264547081/WholeHome-pc.jpg'}
                srcPad="https://websiteoss.ecoflow.com/upload/image/1751264546916/WholeHome-h5.jpg"
                alt={t('Whole_home_title')}
                className="banner"
            />
            <div className="text-container">
                <h3>{t(`Whole_home_sub_title`)}</h3>
                <h2>{t(`Whole_home_title`)}</h2>
            </div>
        </div>
    );
};

export default WholeHome;
